import { render, staticRenderFns } from "./TeamMemberSettingsModal.vue?vue&type=template&id=cf0acd46&scoped=true&"
import script from "./TeamMemberSettingsModal.vue?vue&type=script&lang=js&"
export * from "./TeamMemberSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberSettingsModal.vue?vue&type=style&index=0&id=cf0acd46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0acd46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf0acd46')) {
      api.createRecord('cf0acd46', component.options)
    } else {
      api.reload('cf0acd46', component.options)
    }
    module.hot.accept("./TeamMemberSettingsModal.vue?vue&type=template&id=cf0acd46&scoped=true&", function () {
      api.rerender('cf0acd46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/BatchStop/StepComponents/TeamMemberSettingsModal.vue"
export default component.exports